window.addEventListener('DOMContentLoaded', () => {
  // 1. ページ読み込み時の処理（別ページから#付きで来た場合）
  const hash = window.location.hash;
  if (hash) {
    setTimeout(() => {
      const target = document.querySelector(hash);
      if (target) {
        const headerHeight = 80;
        const position = target.getBoundingClientRect().top + window.pageYOffset - headerHeight;
        window.scrollTo({
          top: position,
          behavior: 'smooth'
        });
      }
    }, 100);
  }

  // 2. 通常のページ内リンククリック時の処理
  const smoothScrollLinks = document.querySelectorAll('a[href^="#"]');
  smoothScrollLinks.forEach(link => {
    link.addEventListener('click', (e) => {
      const href = link.getAttribute('href');
      const target = document.querySelector(href === '#' || href === '' ? 'html' : href);
      if (target) {
        e.preventDefault();
        const headerHeight = 150;
        const position = target.getBoundingClientRect().top + window.pageYOffset - headerHeight;
        window.scrollTo({
          top: position,
          behavior: 'smooth'
        });
        history.pushState(null, null, href);
      }
    });
  });
});
 

//menu
const menuBtn = document.querySelector('.menuBtn');
const menuHeader = document.querySelector('header');
menuBtn?.addEventListener('click', () => {
    menuBtn.classList.toggle('active');
	menuHeader.classList.toggle('menu_back');
});

//リンク
const links = document.querySelectorAll('.nolink');
links.forEach(link => {
    link.addEventListener('click', function(event) {
        event.preventDefault();
    });
});

//table
const plan1_title = document.getElementById('plan1_title');
const plan2_title = document.getElementById('plan2_title');
const plan1 = document.getElementsByClassName('plan_in1');
const plan2 = document.getElementsByClassName('plan_in2');

plan1_title?.addEventListener('click', () => {
	plan1_title.classList.add('add');
    plan1_title.classList.remove('re');
	plan2_title.classList.add('re');
	plan2_title.classList.remove('add');
	
	for(var i = 0; i < plan1.length; ++i){
		plan1[i].classList.add('show');
		plan1[i].classList.remove('hide');
	}
	for(var i = 0; i < plan2.length; ++i){
		plan2[i].classList.add('hide');
		plan2[i].classList.remove('show');
	}
});
plan2_title?.addEventListener('click', () => {
	plan1_title.classList.add('re');
	plan1_title.classList.remove('add');
	plan2_title.classList.add('add');
    plan2_title.classList.remove('re');
	
	for(var i = 0; i < plan2.length; ++i){
		plan2[i].classList.add('show');
		plan2[i].classList.remove('hide');
	}
	for(var i = 0; i < plan1.length; ++i){
		plan1[i].classList.remove('show');
		plan1[i].classList.add('hide');
	}
});



//const review_item = document.querySelectorAll('.review_item');
const review_lightbox = document.querySelector('.top-review_lightbox');
const review_black = document.querySelector('.top-black');

document.querySelector('.review_slider')?.addEventListener('click', function(e) {
    const slideItem = e.target.closest('.review_item');
    if (slideItem) {
        const title = slideItem.querySelector('.top-lightbox').dataset.title;
        const review_img = slideItem.querySelector('.top-lightbox').dataset.img;
        const star = slideItem.querySelector('.top-lightbox').dataset.star;
        const txt = slideItem.querySelector('.top-lightbox').dataset.txt;

        review_lightbox.textContent = '';
        review_lightbox.classList.add('show');
        review_black.classList.add('show');

        var review = "";
        if(review_img !== undefined){
            review += "<div class='top-imgBox'><img src='"+review_img+"' alt='"+title+"'></div>";
		}
		if(star !== undefined){
			review += "<div class='star' style='--rate: "+star+";'></div>";
		}
		if(title !== undefined){
			review += "<p class='title'>"+title+"</p>";
		}
		if(txt !== undefined){
			review += "<div class='top-tx'><p>"+txt+"</p></div>";
		}
        review_lightbox.innerHTML = review;
    }
});

review_black?.addEventListener('click', (event) => {
	review_lightbox.textContent = '';
	review_lightbox.classList.remove('show');
	review_black.classList.remove('show');
});


$(function () {
	
	function campaign(){
        let slide1 = '.campaign_slider';
        if($(slide1).length > 0){
            $(".slider_item").addClass("dis");
            if (!$(slide1).hasClass('slick-initialized')) {			
                $(slide1).slick({
                    mobileFirst: false,
                    slidesToShow: 5,
                    slidesToScroll: 1,                
                    variableWidth: true,
                    autoplay: true,
                    autoplaySpeed: 5000,
                    centerMode: true,
                    arrows:true,
                    centerPadding: "5px",
					dots:false,
					accessibility: false,
					
					responsive: [
                        {
                            breakpoint:1120,
                            settings: {
                                variableWidth:false,
                            },
                        },
						{
                            breakpoint:768,
                            settings: {
								dots:true,
								slidesToShow: 3,
                                variableWidth:true,
                            },
                        },
                    ]
                });
            }
        }
	}
	
	function review(){
        let slide1 = '.review_slider';
        if($(slide1).length > 0){
            $(".slider_item").addClass("dis");
            if (!$(slide1).hasClass('slick-initialized')) {			
                $(slide1).slick({
                    mobileFirst: false,
                    slidesToShow: 4,
                    slidesToScroll: 1,                
                    variableWidth: true,
                    autoplay: true,
                    autoplaySpeed: 5000,
                    centerMode: true,
                    arrows:true,
                    centerPadding: "10px",
					dots:false,
					accessibility: false,
					
					responsive: [
                        {
                            breakpoint:1120,
                            settings: {
                                variableWidth:false,
                            },
                        },
						{
                            breakpoint:768,
                            settings: {
								slidesToShow: 3,
                                variableWidth:true,
                            },
                        },
                    ]
                });
            }
        }
	}

	function rank(){
        let slide2 = '.rank_slider';
        if($(slide2).length > 0){
            $(".slider_item").addClass("dis");
            if (!$(slide2).hasClass('slick-initialized')) {
                $(slide2).slick({
                    mobileFirst: true,
                    slidesToShow: 1,
                    slidesToScroll: 1,                
                    variableWidth: true,
                    autoplaySpeed: 5000,
					dots:true,
                    arrows:false,
                    responsive: [
                        {
                            breakpoint:768,
                            settings: 'unslick'
                        },
                    ]
                });
            }
        }	
	}
	
	function blog(){
        let slide1 = '.blog_slider';
        if($(slide1).length > 0){
            $(".slider_item").addClass("dis");
            if (!$(slide1).hasClass('slick-initialized')) {			
                $(slide1).slick({
                    mobileFirst: true,
                    slidesToShow: 1,
                    slidesToScroll: 1,                
                    variableWidth: true,
                    autoplay: true,
                    autoplaySpeed: 5000,
                    centerMode: true,
                    arrows:false,
                    centerPadding: "20px",
					dots:true,
                    responsive: [
                        {
                            breakpoint:768,
                            settings: 'unslick'
                        },
                    ]
                });
            }
        }
	}

	campaign();
	review();
    rank();
	blog();
	
	let timer = 0;
    window.addEventListener('resize', () => {
      if (timer > 0) {
        clearTimeout(timer);
      }
      timer = setTimeout(() => {
          rank();
		  blog();
      }, 200);
    });
});